import { IOption } from '../../models/IOption';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';


@Component({
  selector: 'ff-searchbar',
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.scss']
})
export class SearchbarComponent implements OnInit {

  /**
   * Options to display in the search bar
   * Use the IOption interface: { value: string; text: string; selected?: boolean; }
   * @internal
   */
  @Input() options: IOption[] = [];

    /**
   * Emit the value selected by the user.
   * @internal
   */
  @Output() optionUpdated = new EventEmitter<IOption>();

  myControl = new FormControl();
  filteredOptions: Observable<IOption[]>;
  initialValue: IOption = { text: '', value: '', selected: false };
  optionSelected: IOption;
  constructor() { }

  ngOnInit(): void {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => typeof value === 'string' ? value : value.text),
      map(name => name ? this._filter(name) : this.options.slice())
    );

  }


  private _filter = (value): IOption[] => {
    let filterValue: string = '';
    if (!!value) {
      value.text !== undefined
        ? filterValue = value.text.toLowerCase()
        : filterValue = value.toLowerCase();

      return this.options.filter(option => option.text.toLowerCase().indexOf(filterValue) === 0);

    }

    return this.options.filter(option => option.text.toLowerCase().indexOf(filterValue) === 0);

  }

  saveSelected = (option: IOption): string => {
    this.optionSelected = option;
    return option.text;

  }

  onOptionSelected = (): void => {
    !!this.optionUpdated
    ? this.optionUpdated.emit(this.optionSelected)
    : '';
  }

}
